module.exports = __webpack_public_path__ + "static/img/home_12.e7a32e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_12.jpg
// module id = ZLXu
// module chunks = 1